import {rest} from './rest';

import * as constants from './constants';
import * as selectors from './selectors';

export const escalations = {
    rest,
    constants,
    selectors,
};
